import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getPortalFromPath } from '@/lib/portalConfig';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-journey-atmosphere flex items-center justify-center" aria-busy="true" aria-label="Loading">
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" aria-hidden="true" />
      </div>
    );
  }

  if (!user) {
    // Redirect to portal-specific auth if inside a portal, otherwise global auth
    const portal = getPortalFromPath(location.pathname);
    const authPath = portal ? `/${portal}/auth` : '/auth';
    return <Navigate to={authPath} state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
